<template>
  <div
    v-show="hasbubble==1"
    :id="smallbubbleid"
    :class="smallbubbleclass"
    class="d-none d-sm-none d-lg-inline-block"
    @click.prevent="showhidebubble"
  >
    ?
  </div>
</template>
<script>
export default {
  name: 'PopupBubble',
  props: {
    screenId: {
      type: Number,
      default: 0
    },
    screenelementId: {
      type: String,
      default: '0'
    },
    bubbletext: {
      type: String,
      default: ''
    },
    smallbubbleclass: {
      type: String,
      default: 'smallbubble'
    }
  },
  data: function () {
    return {
      smallbubbleid: 's' + this.$props.screen_id + '_' + this.$props.screenelement_id,
      bubbleid: this.$props.screen_id + '_' + this.$props.screenelement_id,
      hasbubble: 0,
      bubbleopen: false
    }
  },
  mounted: function () {
    setTimeout(() => {
      this.bubble_get()
    }, 1000)
  },
  methods: {
    bubble_get () {
      this.hasbubble = 0
      if (this.$props.bubbletext != null && this.$props.bubbletext.length > 0 && this.$props.bubbletext != '') {
        var bubbletext = this.$props.bubbletext
        var bubble = document.getElementById(this.bubbleid)
        var smallbubble = document.getElementById(this.smallbubbleid)
        if (!bubble) {
          bubble = document.createElement('div')
          bubble.id = this.bubbleid
          var bubbletextdiv = document.createElement('div')
          bubbletextdiv.innerHTML = bubbletext
          bubble.appendChild(bubbletextdiv)
          document.body.appendChild(bubble)
          bubble.className = 'bigbubble'
          bubble.style.position = 'absolute'
          bubble.style.zIndex = 1000
        }
        bubble.style.display = 'none'
        smallbubble.style.display = ''
        this.hasbubble = 1
      }
    },
    hidebubble () {
      var bubble = document.getElementById(this.bubbleid)
      var smallbubble = document.getElementById(this.smallbubbleid)
      smallbubble.style.display = ''
      bubble.style.display = 'none'
    },
    showhidebubble (e) {
      var target = e.target
      var rect = target.getBoundingClientRect()
      var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop
      var top = rect.top + scrollTop
      var left = rect.left + scrollLeft
      if (this.bubbleopen) {
        this.hidebubble()
        this.bubbleopen = false
      } else {
        var bubble = document.getElementById(this.bubbleid)
        if (bubble == null) {
          this.bubble_get()
          bubble = document.getElementById(this.bubbleid)
        }
        this.bubbleopen = true
        // var smallbubble = document.getElementById(this.smallbubbleid)
        if (this.smallbubbleclass == 'smallbubble') {
          bubble.style.top = (top + 76) + 'px'
          bubble.style.left = (left - 126) + 'px'
        } else {
          bubble.style.top = (top + 60) + 'px'
          bubble.style.left = (left - 136) + 'px'
        }
        bubble.style.display = ''
      }
    }
  }
}
</script>
<style>
</style>
